import React, { useEffect, useState } from "react";
import { Box, Chip, Typography, List, ListItem, ListItemText, Divider, Tabs, Tab, ListItemButton, Checkbox, IconButton, Tooltip } from "@mui/material";
import { Delete, MarkEmailRead, MarkEmailUnread } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'store';
import useAuth from "hooks/useAuth";
import useAPI from "hooks/useAPI";
import EmployeeService from 'services/EmployeeService';
import { EMPLOYER_ROLE, CS_TECHNICAL_ROLE, CS_OTHERS_ROLE } from 'config';
import moment from 'moment';

const NotificationList = ({ reload, setReload }) => {
    const navigate = useNavigate();
    const { isLoggedIn, user } = useAuth();
    const role = user.role;
    const company_uuid = useSelector((state) => state.user.profile.companyUUID);
    const employee_uuid = useSelector((state) => state.user.profile.employeeUUID);

    const [notifications, setNotifications] = useState([]);
    const [selectedNotifications, setSelectedNotifications] = useState(new Set());
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(15);
    const [unreadCount, setCount] = useState(0);


    const handleNotifiList = (response) => {
        setNotifications(response.data.items);
        // setNotifications(prevNotifications => [...prevNotifications, ...response.data.items]);
    };

    const handleClick = (notification) => {
        readStatus.execute(company_uuid, employee_uuid, notification.uuid);
    };

    const handleNotifiRead = () => {
        console.log("Notification read status updated");
    };

    const handleAllRead = () => {
        setReload(r => !r);
        console.log("Notification all read status updated");
    };
    const handleUnreadCount = (response) => {
        setCount(response.data.unreadCount);
    };

    const notiList = useAPI(EmployeeService.notificationList, handleNotifiList);
    const readStatus = useAPI(EmployeeService.notifiReadStatus, handleNotifiRead);
    const markAllRead = useAPI(EmployeeService.allReadNotification, handleAllRead);
    const unreadCountApi = useAPI(EmployeeService.unreadCount, handleUnreadCount);

    useEffect(() => {
        if (user && user.role !== EMPLOYER_ROLE && user.role !== CS_TECHNICAL_ROLE && user.role !== CS_OTHERS_ROLE) {
            notiList.execute(company_uuid, employee_uuid, page, 15, limit);
            unreadCountApi.execute(company_uuid, employee_uuid);
        }
    }, [company_uuid, employee_uuid, page, limit, reload]);

    const formatDate = (dateString) => {
        const today = moment().startOf('day');
        const yesterday = moment().subtract(1, 'days').startOf('day');
        const notificationDate = moment(dateString);

        if (notificationDate.isSame(today, 'day')) return 'Today';
        if (notificationDate.isSame(yesterday, 'day')) return 'Yesterday';
        return notificationDate.format('DD-MM-YYYY');
    };

    const groupNotificationsByDate = () => {
        return notifications.reduce((groups, notification) => {
            const date = formatDate(notification.createdAt);
            if (!groups[date]) {
                groups[date] = [];
            }
            groups[date].push(notification);
            return groups;
        }, {});
    };

    const toggleSelectNotification = (uuid) => {
        setSelectedNotifications((prev) => {
            const newSelection = new Set(prev);
            if (newSelection.has(uuid)) newSelection.delete(uuid);
            else newSelection.add(uuid);
            return newSelection;
        });
    };

    const markAsRead = () => {
        selectedNotifications.forEach(uuid => readStatus.execute(company_uuid, employee_uuid, uuid));
        setSelectedNotifications(new Set());
    };

    const markAllAsread = () => {
        console.log('Clickable');
        // selectedNotifications.forEach(uuid => markAllRead.execute(company_uuid, employee_uuid, uuid));
        markAllRead.execute(company_uuid, employee_uuid)
        setSelectedNotifications(new Set());
    };

    const deleteSelected = () => {
        // deleteNotifications.execute(Array.from(selectedNotifications));
        setNotifications(notifications.filter(notif => !selectedNotifications.has(notif.uuid)));
        setSelectedNotifications(new Set());
    };

    // const unreadCount = notifications.filter(notification => notification.readStatus).length;
    const groupedNotifications = groupNotificationsByDate();

    return (
        <Box display="flex" height="100vh">
            {/* <Box width={"250px"} bgcolor="#2D3E8B" color="white" p={2} display="flex" flexDirection="column">
                <Tabs orientation="vertical" variant="scrollable" textColor="inherit" indicatorColor="primary">
                    <Tab label="Dashboard" onClick={() => navigate(`/${role}/dashboard`)} />
                    <Tab label="Employee" onClick={() => navigate(`/${role}/employees`)} />
                    <Tab label="Timesheet" onClick={() => navigate(`/${role}/timesheet`)} />
                    <Tab label="Expenses" onClick={() => navigate(`/${role}/expenses`)} />
                    <Tab label="Payroll" onClick={() => navigate(`/${role}/payroll`)} />
                    {role === EMPLOYER_ROLE ? (
                        <>
                            <Tab label="Tax Approvals" onClick={() => navigate(`/${role}/tax-approvals`)} />
                            <Tab label="Support" onClick={() => navigate(`/${role}/support`)} />
                        </>
                    ) : (
                        <Tab label="Savings" onClick={() => navigate(`/${role}/savings`)} />
                    )}
                </Tabs>
            </Box> */}

            <Box flex={1} p={3}>
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h3" fontWeight="bold">Notifications</Typography>
                    {/* <Box>
                        <Tooltip placement="top" title="Mark as Read" ><IconButton color="primary" onClick={markAsRead} disabled={!selectedNotifications.size}><MarkEmailRead /></IconButton></Tooltip>
                        <Tooltip placement="top" title="Mark All read" ><IconButton color="primary" onClick={markAllAsread} disabled={!selectedNotifications.size}><MarkEmailUnread /></IconButton></Tooltip>
                        <Tooltip placement="top" title="Delete"><IconButton color="primary" onClick={deleteSelected} disabled={!selectedNotifications.size}><Delete /></IconButton></Tooltip>
                    </Box> */}
                </Box>
                <Typography>You have <Typography component="span" variant="h4" color="primary">{unreadCount}</Typography> unread notifications.&nbsp;&nbsp;

                    <Chip
                        label="Mark all as read"
                        onClick={markAllAsread}
                        // disabled={!selectedNotifications.size}
                        color="primary" // Uses the primary color from your theme
                        clickable
                    />
                </Typography>
                <List sx={{ maxHeight: '80vh', mt: 2, overflowY: 'auto', scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" }, msOverflowStyle: "none", }}>
                    {Object.keys(groupedNotifications).map(date => (
                        <React.Fragment key={date}>
                            <Typography variant="h6" sx={{ mt: 2, mb: 1 }} fontWeight="bold">{date}</Typography>
                            {groupedNotifications[date].map(notification => (
                                <React.Fragment key={notification.uuid}>
                                    <ListItem
                                        sx={{
                                            backgroundColor: selectedNotifications.has(notification.uuid) ? "#D3E3FC" : (notification.readStatus ? "transparent" : "#E0E3FF"),
                                            borderRadius: "5px",
                                            mb: 1
                                        }}
                                    >
                                        {/* <Checkbox checked={selectedNotifications.has(notification.uuid)} onChange={() => toggleSelectNotification(notification.uuid)} /> */}
                                        <ListItemButton onClick={() => handleClick(notification)}>
                                            <ListItemText
                                                primary={
                                                    <>
                                                        <Typography color="blue" fontWeight="bold">
                                                            {notification.title}
                                                        </Typography>
                                                        <Typography>{notification.description}</Typography>
                                                    </>
                                                }
                                                secondary={
                                                    <Typography variant="caption">
                                                        {notification.createdAt.split(' ')[1]} {/* Display the time */}
                                                    </Typography>
                                                }
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                    <Divider />
                                </React.Fragment>
                            ))}
                        </React.Fragment>
                    ))}
                </List>
            </Box>
        </Box>
    );
};

export default NotificationList;
